export const CHECKOUT_URL = 'https://mountain-bike-coach-ready.impultienda.ar/checkout'

const PRODUCT_NAME = 'Mountain Bike Coach Ready — Complete 6-in-1 MTB Coaching System'
const PRODUCT_VALUE = 27

type PixelWindow = Window & {
  fbq?: (event: string, name: string, data: Record<string, string | number>) => void
}

export function trackCheckout(): void {
  if (typeof window === 'undefined') return
  const pixelWindow = window as PixelWindow
  pixelWindow.fbq?.('track', 'InitiateCheckout', {
    content_name: PRODUCT_NAME,
    value: PRODUCT_VALUE,
    currency: 'USD',
  })
}
